export async function clientRevalidate(path: string) {
	return fetch(`/api/revalidate?path=${path}`);
}

export async function clientRevalidateAll() {
	return fetch(`/api/revalidate`, { method: "DELETE" });
}
